import { fromJS } from 'immutable';

export function request(state) {
    return state.set('updateRelatedContingencyLabel', fromJS({
        status: 'IN_PROGRESS'
    }));
}

export function finish(state, { data }) {
    return state.set('updateRelatedContingencyLabel', fromJS({
        status: 'FINISHED',
        data
    }));
}

export function error(state) {
    return state.set('updateRelatedContingencyLabel', fromJS({
        status: 'ERROR'
    }));
}
